import React, { useEffect, useState } from 'react';
import PageContent from '../../components/layout/PageContent';
import axios from 'axios';
import CustomForm from '../../components/form/CustomForm';
import { useHistory } from 'react-router-dom';

const EditAccessItem = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = useState([]);
	const [ loadingFields, setLoadingFields ] = useState(false);

	const history = useHistory();

	useEffect(() => {
		setLoadingFields(true);
		axios.get(`/api/1.0/accessitem/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			setFields(result?.data ?? []);
		})
		.catch(err => {
			console.error('Fetch Access Item: ', err);
		})
		.finally(() => setLoadingFields(false))
	}, [id]);

	const handleSubmit = (fields) => {
		return axios.post(`/api/1.0/accessitem/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/accessitem');
			}
		})
		.catch(err => {
			console.error('Update Access Item: ', err);
		})
	}

	const handleCancel = () => {
		history.push('/accessitem')
	};

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Хандах эрх засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				loading={loadingFields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default EditAccessItem;